import {cn} from '@tempmee/core'
import {type HTMLAttributes, forwardRef} from 'react'

export interface TableRowProps extends HTMLAttributes<HTMLTableRowElement> {
  /** Tint the row on hover (`action.focus`, rgba(173,248,255,0.16)). @default false */
  hover?: boolean
  /** Persistent selected tint (`action.hover`, rgba(173,248,255,0.32)). @default false */
  selected?: boolean
}

/**
 * TableRow (v3, MUI-aligned) — renders `<tr>`. Mirrors `@mui/material/TableRow`:
 * `hover` adds a light-aqua tint on `:hover`; `selected` keeps the (stronger)
 * tint persistently and sets `aria-selected`. Per the Figma "Style" matrix the
 * hover tint is the `action.focus` token (0.16) and selected is `action.hover`
 * (0.32) — the same inverted naming already shipped in `Radio`.
 */
export const TableRow = forwardRef<HTMLTableRowElement, TableRowProps>(
  ({className, hover = false, selected = false, ...props}, ref) => (
    <tr
      ref={ref}
      aria-selected={selected || undefined}
      className={cn(
        'transition-colors',
        hover && 'hover:bg-action-focus',
        selected && 'bg-action-hover',
        className,
      )}
      {...props}
    />
  ),
)
TableRow.displayName = 'TableRow'
